(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3704],{

/***/ 32167:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partnerships/[slug]",
      function () {
        return __webpack_require__(10131);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PARTNERSHIP_FORM_MAP": function() { return /* binding */ PARTNERSHIP_FORM_MAP; },
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(828);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(33587);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(63430);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(12569);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(44087);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8814);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80338);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26499);
/* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47446);
/* harmony import */ var _modules__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18838);
/* harmony import */ var _providers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(90663);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(20978);
/* harmony import */ var _narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67199);
/* harmony import */ var _narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_10__);


















var ArrowLink = function(param) {
    var href = param.href, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
        href: href,
        className: "group relative block py-2 pr-15 mt-6 border-b border-black",
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .RightArrowIcon */ .AD, {
                className: "absolute bottom-0 right-0 mb-3 transition-transform duration-200 transform -translate-x-3 group-hover:translate-x-0"
            })
        ]
    });
};
var __N_SSG = true;
var PARTNERSHIP_FORM_MAP = {
    "paid-content": _components__WEBPACK_IMPORTED_MODULE_4__/* .PaidContentForm */ .eM,
    instagram: _components__WEBPACK_IMPORTED_MODULE_4__/* .InstagramForm */ .TB,
    blogger: _components__WEBPACK_IMPORTED_MODULE_4__/* .BloggerForm */ .gv,
    ambassador: _components__WEBPACK_IMPORTED_MODULE_4__/* .AmbassadorForm */ .tR,
    workshops: _components__WEBPACK_IMPORTED_MODULE_4__/* .WorkshopsForm */ .M8
};
var PartnershipPage = function(param) {
    var preview = param.preview, subscription = param.subscription;
    var alertDispatch = (0,_providers__WEBPACK_IMPORTED_MODULE_8__/* .useAlertDispatch */ .CR)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), height = ref[0], setHeight = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isSuccess = ref1[0], setSuccess = ref1[1];
    var formContainer = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var data = (0,react_datocms__WEBPACK_IMPORTED_MODULE_11__/* .useQuerySubscription */ .L)(subscription).data;
    if (!data) return null;
    var otherPages = data.otherPages, _page = data.page, seo = _page.seo, title = _page.title, date = _page.date, form = _page.form, image = _page.image, author = _page.author, content = _page.content;
    // Form
    var Form = PARTNERSHIP_FORM_MAP[form];
    // Handle submit
    var handleSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var values, actions, fieldMap, hiddenInputs, data, response;
            return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        values = param.values, actions = param.actions, fieldMap = param.fieldMap, hiddenInputs = param.hiddenInputs;
                        _ctx.prev = 1;
                        // Set form container height for a smoother fade in of the success message
                        if (formContainer.current) {
                            setHeight(formContainer.current.clientHeight);
                        }
                        data = Object.entries(values).reduce(function(accumulator, param) {
                            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, accumulator), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, fieldMap[key], value));
                        }, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, hiddenInputs));
                        if (!_config__WEBPACK_IMPORTED_MODULE_5__/* .IS_DEVELOPMENT */ .v9) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 7;
                        return (0,_utils__WEBPACK_IMPORTED_MODULE_9__/* .mockApiRequest */ .Xv)();
                    case 7:
                        _ctx.t0 = _ctx.sent;
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.next = 12;
                        return _api__WEBPACK_IMPORTED_MODULE_3__/* .Api.sendActiveCampaignsForm */ .V0.sendActiveCampaignsForm(data);
                    case 12:
                        _ctx.t0 = _ctx.sent;
                    case 13:
                        response = _ctx.t0;
                        if (!((response === null || response === void 0 ? void 0 : response.status) >= 200 && (response === null || response === void 0 ? void 0 : response.status) < 300)) {
                            _ctx.next = 18;
                            break;
                        }
                        {
                            setSuccess(true);
                        }
                        _ctx.next = 19;
                        break;
                    case 18:
                        throw new Error();
                    case 19:
                        _ctx.next = 26;
                        break;
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t1 = _ctx["catch"](1);
                        setSuccess(false);
                        alertDispatch({
                            type: _narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_10__.AlertActionType.SetContent,
                            payload: {
                                type: "error",
                                title: "There was an error submitting your form. Please try again."
                            }
                        });
                        /**
       * Send an event to track form failures.
       * We're sending the form type, error message and the values entered by the user
       */ (0,_events__WEBPACK_IMPORTED_MODULE_6__/* .publishEvent */ .s0)(_events__WEBPACK_IMPORTED_MODULE_6__/* .TOPICS.partnershipFormFailed */ .Nl.partnershipFormFailed, {
                            form: form,
                            error: _ctx.t1,
                            values: values
                        });
                    case 26:
                        _ctx.prev = 26;
                        // Dirty timeout to prevent the success message transition being affected by resetting the form state
                        setTimeout(function() {
                            actions.setSubmitting(false);
                        }, 1000);
                        return _ctx.finish(26);
                    case 29:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    21,
                    26,
                    29
                ]
            ]);
        }));
        return function handleSubmit(_) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Layout */ .Ar, {
        preview: preview,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .SEO */ .HJ, {
                title: "".concat(title, " | Narrative"),
                children: (0,react_datocms__WEBPACK_IMPORTED_MODULE_17__/* .renderMetaTags */ .y)(seo)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Section */ .$0, {
                isFirstSection: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W2, {
                    className: "flex flex-col items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "max-w-4xl",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                                    className: "text-h2 font-semibold text-center leading-tight lg:text-h1",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_10__.HorizontalRule, {
                                    topMargin: true
                                })
                            ]
                        }),
                        image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "mt-10 border border-current",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_datocms__WEBPACK_IMPORTED_MODULE_18__/* .Image */ .E, {
                                data: image.responsiveImage
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "w-full max-w-200",
                            children: [
                                author && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "my-8",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .BlogAuthor */ .p8, {
                                        name: author.name,
                                        date: date,
                                        image: author.avatar
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "prose text-stealth-bomber",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_modules__WEBPACK_IMPORTED_MODULE_7__/* .StructuredText */ .rZ, {
                                        data: content
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Section */ .$0, {
                className: "bg-white",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W2, {
                    className: "flex flex-col items-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        ref: formContainer,
                        className: "w-full max-w-200 overflow-hidden",
                        style: {
                            maxHeight: height ? "".concat(height, "px") : "none"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_19__/* .Transition */ .u, {
                                show: !isSuccess,
                                leave: "transition-opacity duration-500",
                                leaveFrom: "opacity-100",
                                leaveTo: "opacity-0",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_10__.HorizontalRule, {
                                        bottomMargin: true
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Form, {
                                        onSubmit: handleSubmit
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_19__/* .Transition */ .u, {
                                show: isSuccess,
                                enter: "transition-opacity duration-500 delay-500",
                                enterFrom: "opacity-0",
                                enterTo: "opacity-100",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_10__.HorizontalRule, {
                                        bottomMargin: true
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .SuccessMessage */ .kk, {})
                                ]
                            })
                        ]
                    })
                })
            }),
            otherPages.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Section */ .$0, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W2, {
                    className: "flex flex-col items-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "w-full max-w-200",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_10__.HorizontalRule, {
                                bottomMargin: true
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                className: "text-h3 font-semibold leading-compact text-center lg:text-h2",
                                children: "Other ways to partner up"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "mt-12",
                                children: [
                                    otherPages.map(function(param) {
                                        var id = param.id, title = param.title, slug = param.slug, parentPage = param.parentPage;
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ArrowLink, {
                                            href: "/".concat(parentPage.slug, "/").concat(slug),
                                            children: title
                                        }, id);
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ArrowLink, {
                                        href: "/".concat(_config__WEBPACK_IMPORTED_MODULE_5__/* .ROUTES.PARTNERSHIPS.SLUG */ .Z6.PARTNERSHIPS.SLUG),
                                        children: "Partnerships page"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PartnershipPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(32167); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);